import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ProseSection } from './RichBlocks';

/**
 * Renders the intent-matched content sections produced by the v2 rewrite
 * engine (rewriteSEOPage). Only renders when the page has been migrated
 * (content_version >= 2) — legacy boilerplate sections stay hidden.
 */
export function hasV2Content(page) {
  return (page?.content_version || 0) >= 2
    && Array.isArray(page?.content_sections)
    && page.content_sections.length > 0;
}

export default function V2Sections({ page, startAlt = false }) {
  if (!hasV2Content(page)) return null;
  return (
    <>
      {page.content_sections.map((s, i) => (
        <ProseSection
          key={i}
          id={`sektion-${i + 1}`}
          heading={s.heading}
          alt={(i % 2 === 0) === startAlt}
        >
          <ReactMarkdown className="prose prose-slate max-w-none prose-a:text-[#2F424D] prose-a:underline">
            {s.body}
          </ReactMarkdown>
        </ProseSection>
      ))}
    </>
  );
}